import React, { useState, useEffect } from "react";

import Header from "../../components/header/header";
import comfort from "../../images/slide-1.jpg";
import luxurySUV from "../../images/slide-7.jpg";
import suv from "../../images/teramount.webp";
import business from "../../images/EQE.jpg";
import { useNavigate, useLocation } from "react-router-dom";
import "./bookingForm.css";
import VehicleSelect from "../../components/vehicleSelect/vehicleSelect";
import BookingFooter from "../../components/bookingFooter/bookingFooter";
import RideSummary from "../../components/rideSummary/rideSummary";

const BookingForm = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    pickup,
    tripType,
    destination,
    distance,
    pickupTime,
    pickupDate,
    duration,
  } = Object.fromEntries(new URLSearchParams(location.search));
  const [comfortPrice, setComfortPrice] = useState(0);
  const [businessPrice, setBusinessPrice] = useState(0);
  const [fare, setFare] = useState(comfortPrice);
  const [suvPrice, setSuvPrice] = useState(0);
  const [luxurySuvPrice, setLuxurySuvPrice] = useState(0);
  const [selectedVehicle, setSelectedVehicle] = useState("Comfort");
  const distDurationValue =
    duration == null ? distance + " KM" : duration + " Hours";
  const vehicles = [
    {
      id: 1,
      vehicleType: "Comfort",
      image: comfort,
      name: "Comfort",
      features: "Lexus ES 300H, Tesla Model Y or Similar",
      capacity: 4,
      luggage: 2,
      fare: comfortPrice,
      active: selectedVehicle === "Comfort",
    },
    {
      id: 2,
      vehicleType: "SUV",
      image: suv,
      name: "SUV",
      features: "Volkswagen Teramont",
      capacity: 6,
      luggage: 4,
      fare: suvPrice,
      active: selectedVehicle === "SUV",
    },
    {
      id: 3,
      vehicleType: "Business",
      image: business,
      name: "Business",
      features: "Mercedes-Benz EQE",
      capacity: 4,
      luggage: 2,
      fare: businessPrice,
      active: selectedVehicle === "Business",
    },
    {
      id: 4,
      vehicleType: "LuxurySUV",
      image: luxurySUV,
      name: "LuxurySUV",
      features: "Mercedes Benz V250",
      capacity: 7,
      luggage: 4,
      fare: luxurySuvPrice,
      active: selectedVehicle === "LuxurySUV",
    },
  ];

  const calculatePrice = () => {
    let comfortBasePrice = 60;
    let suvBasePrice = 75;
    let businessBasePrice = 100;
    let luxurySUVBasePrice = 100;

    let tempComfortPrice;
    let tempBusinessPrice;
    let tempSuvPrice;
    let tempLuxurySuvPrice;

    if (tripType === "singleTrip") {
      tempComfortPrice = Math.round((distance * 2.5 * 100) / 100);
      tempBusinessPrice = Math.round((distance * 3.5 * 100) / 100);
      tempSuvPrice = Math.round((distance * 2.7 * 100) / 100);
      tempLuxurySuvPrice = Math.round((distance * 3.5 * 100) / 100);
    } else {
      tempComfortPrice = duration * 90;
      tempBusinessPrice = duration * 110;
      tempSuvPrice = duration * 95;
      tempLuxurySuvPrice = duration * 110;
    }

    const airportParkingCharges = 40;
    const lowercasePickup = pickup.toLowerCase();
    let lowercaseDestination = "";
    if (destination) {
      lowercaseDestination = destination.toLowerCase();
    }
    const comfortAirportBasePrice = 200;
    const suvAirportBasePrice = 200;
    const luxuryAirportBasePrice = 250;
    const intercityCharges = 80;
    const airportDropOffAdditionalPrice = 50;

    if (
      pickup &&
      (lowercasePickup.includes("airport") ||
        lowercasePickup.includes("terminal"))
    ) {
      tempComfortPrice += airportParkingCharges;
      tempComfortPrice =
        tempComfortPrice > comfortAirportBasePrice
          ? tempComfortPrice
          : comfortAirportBasePrice;
      tempBusinessPrice += airportParkingCharges;
      tempBusinessPrice =
        tempBusinessPrice > luxuryAirportBasePrice
          ? tempBusinessPrice
          : luxuryAirportBasePrice;
      tempSuvPrice += airportParkingCharges;
      tempSuvPrice =
        tempSuvPrice > suvAirportBasePrice ? tempSuvPrice : suvAirportBasePrice;
      tempLuxurySuvPrice += airportParkingCharges;
      tempLuxurySuvPrice =
        tempLuxurySuvPrice > luxuryAirportBasePrice
          ? tempLuxurySuvPrice
          : luxuryAirportBasePrice;
    }
    if (
      destination &&
      (lowercaseDestination.includes("airport") ||
        lowercaseDestination.includes("terminal"))
    ) {
      comfortBasePrice += airportDropOffAdditionalPrice;
      suvBasePrice += airportDropOffAdditionalPrice;
      luxurySUVBasePrice += airportDropOffAdditionalPrice;
      businessBasePrice += airportDropOffAdditionalPrice;
    }
    const locations = ["ajman", "sharjah", "fujairah", "khaimah", "rak"];

    if (
      locations.some((location) => lowercasePickup.includes(location)) ||
      locations.some((location) => lowercaseDestination.includes(location))
    ) {
      tempComfortPrice += intercityCharges;
      tempBusinessPrice += intercityCharges;
      tempSuvPrice += intercityCharges;
      tempLuxurySuvPrice += intercityCharges;
    }

    tempComfortPrice =
      tempComfortPrice > comfortBasePrice ? tempComfortPrice : comfortBasePrice;
    tempBusinessPrice =
      tempBusinessPrice > businessBasePrice
        ? tempBusinessPrice
        : businessBasePrice;
    tempLuxurySuvPrice =
      tempLuxurySuvPrice > luxurySUVBasePrice
        ? tempLuxurySuvPrice
        : luxurySUVBasePrice;
    tempSuvPrice = tempSuvPrice > suvBasePrice ? tempSuvPrice : suvBasePrice;
    setComfortPrice(tempComfortPrice);
    setFare(tempComfortPrice);
    setBusinessPrice(tempBusinessPrice);
    setSuvPrice(tempSuvPrice);
    setLuxurySuvPrice(tempLuxurySuvPrice);
  };
  const onVehicleSelect = (vehicleType = "Comfort") => {
    let fare = 0;

    switch (vehicleType) {
      case "LuxurySUV":
        fare = luxurySuvPrice;
        break;
      case "Business":
        fare = businessPrice;
        break;
      case "SUV":
        fare = suvPrice;
        break;
      case "Comfort":
      default:
        fare = comfortPrice;
    }
    setFare(fare);
    setSelectedVehicle(vehicleType);
  };
  const onContinueClick = () => {
    const dataToPass = {
      pickupLocation: pickup,
      dropOffLocation: destination,
      distance,
      duration,
      tripType,
      fare,
      pickupDate,
      pickupTime,
      vehicleType: selectedVehicle,
      distDurationValue,
    };
    navigate("/pickup-info", { state: dataToPass });
  };
  useEffect(() => {
    const handleScroll = () => {
      const scroll = window.scrollY; // Get the current scroll position
      const element = document.querySelector("header");
      if (element) {
        if (scroll >= 10) {
          element.classList.add("lightHeader");
          // document.body.classList.add("dark");
        } else {
          document.querySelector("header").classList.remove("lightHeader");
          // document.body.classList.remove("dark");
        }
      }
    };
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll); // Cleanup the event listener on unmount
    };
  }, []);
  useEffect(() => {
    document.body.classList.remove("dark");
    calculatePrice();
  }, []);
  return (
    <>
      <Header></Header>
      <div className="content_">
        {/* Content Inner */}
        <div className="content__inner">
          <div className="overflow-hidden">
            <div className="multisteps-form">
              <div className="progress-row">
                <div className="row">
                  <div className="col-12 col-lg-12 ml-auto mr-auto mb-4 mt-5">
                    <div className="multisteps-form__progress flex space-x-4">
                      <button
                        className="multisteps-form__progress-btn js-active bg-blue-500 text-white py-2 px-4 rounded"
                        type="button"
                        title="Service Class"
                      >
                        <span>Service Class</span>
                      </button>
                      <button
                        className="multisteps-form__progress-btn bg-gray-200 text-gray-700 py-2 px-4 rounded hover:bg-blue-500 hover:text-white transition"
                        type="button"
                        title="Pickup Info"
                      >
                        <span>Pickup Info</span>
                      </button>
                      <button
                        className="multisteps-form__progress-btn bg-gray-200 text-gray-700 py-2 px-4 rounded hover:bg-blue-500 hover:text-white transition"
                        type="button"
                        title="Payment"
                      >
                        <span>Payment</span>
                      </button>
                      <button
                        className="multisteps-form__progress-btn bg-gray-200 text-gray-700 py-2 px-4 rounded hover:bg-blue-500 hover:text-white transition"
                        type="button"
                        title="Thankyou"
                      >
                        <span>Thank You</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-lg-8 m-auto">
                  <form class="multisteps-form__form">
                    <div
                      className="multisteps-form__panel rounded js-active"
                      data-animation="scaleIn"
                    >
                      <div className="step_details mb-5">
                        <input
                          type="hidden"
                          name="vehicleType"
                          id="vehicleType"
                          value="Comfort"
                        />
                        {/* <div className="ride_summery">
                          <div className="Ride_dateTime">
                            {formatPickupDate(pickupDate) +
                              " at " +
                              pickupTime +
                              " (GST)"}
                          </div>
                          <div className="ride_pickupdropoff">
                            <div className="pickupDropoffText pickup">
                              {removeUAE(pickup)}
                            </div>
                            <div style={{ padding: "0 3px" }}>
                              <svg
                                role="img"
                                className="arrow_icon"
                                width="25"
                                height="20"
                                fill="currentColor"
                                viewBox="0 0 24 24"
                                style={{ verticalAlign: "top" }}
                              >
                                <path d="M16.172 11l-5.364-5.364 1.414-1.414L20 12l-7.778 7.778-1.414-1.414L16.172 13H4v-2z" />
                              </svg>
                            </div>
                            <div className="pickupDropoffText destination">
                              {removeUAE(destination)}
                            </div>
                          </div>
                          <div className="ride_duration">
                            <span className="ride_distance">
                              {distDurationValue}
                            </span>
                          </div>
                        </div> */}
                        <RideSummary
                          pickup={pickup}
                          destination={destination}
                          pickupDate={pickupDate}
                          pickupTime={pickupTime}
                          distDurationValue={distDurationValue}
                          tripType={tripType}
                        ></RideSummary>

                        <p className="include-pp">
                          All prices include VAT, fees, and tolls
                        </p>
                        <div className="car-list-block">
                          {vehicles.map((vehicle) => {
                            // console.log(vehicle.image);
                            return (
                              <VehicleSelect
                                vehicle={vehicle}
                                key={vehicle.id}
                                onVehicleSelect={onVehicleSelect}
                              ></VehicleSelect>
                            );
                          })}
                        </div>
                      </div>
                      <BookingFooter
                        onContinueClick={() => onContinueClick()}
                      ></BookingFooter>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BookingForm;
